// extracted by css-extract-rspack-plugin
var _1 = "days-GQde5y";
var _2 = "times-EdSNS4";
export { _1 as "days", _2 as "times" }
